import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Logo from 'design-system/Logo';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import BlurAmountView from 'design-system/BlurAmountView';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import { formatAmount } from 'utils/formatting';
import createStyleSheets from 'utils/createStyleSheets';
import { formatDateForItem } from '../utils';
import { useStockMeta } from '../hooks/selectors';
import { STOCK_ICON_SIZE, ROW_ITEM_HORIZONTAL_PADDING, ROW_ITEM_VERTICAL_PADDING } from '../constants';
import { isWeb } from '../../../constants';
const strings = {
    dividend: 'DIVIDEND',
};
const DividendActivityItem = ({ item, isFirstInSection, isLastInSection, withWrapper }) => {
    const styles = useStyles(styleSet);
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const stockCache = useStockMeta(item.assetId);
    const { amount } = item;
    const borderStyles = useMemo(() => [styles.wrapper, isFirstInSection && styles.firstItem, isLastInSection && styles.lastItem], [styles.wrapper, styles.firstItem, styles.lastItem, isFirstInSection, isLastInSection]);
    return (<View style={[styles.itemContainer, withWrapper && borderStyles]}>
      <Logo R44 uri={stockCache?.iconUrl} resizeMode="contain"/>
      <Spacer w={16}/>
      <View style={styles.infoContainer}>
        <View style={styles.infoRow}>
          <Text Text-14 Gray flex>
            {strings.dividend}
          </Text>
          <BlurAmountView enabled={scrambled}>
            <Text Numbers-16 Blue>
              {`+${formatAmount(amount.value, amount.currency, 2)}`}
            </Text>
          </BlurAmountView>
        </View>
        <View style={styles.infoRow}>
          <Text Text-16 flex numberOfLines={1}>
            {stockCache?.name || item.symbol}
          </Text>
          <Text TextThin-14 Gray>
            {formatDateForItem(item.timestamp)}
          </Text>
        </View>
      </View>
    </View>);
};
const ICON_CONTAINER_SIZE = rem(STOCK_ICON_SIZE);
const styleSet = createStyleSheets((colors) => ({
    itemContainer: {
        alignItems: 'center',
        flexDirection: 'row',
        paddingHorizontal: rem(ROW_ITEM_HORIZONTAL_PADDING),
        paddingVertical: rem(ROW_ITEM_VERTICAL_PADDING),
        // On web the card is padded by 8 and each row by 8, so the hover highlight sits inside the card
        ...(isWeb && { paddingHorizontal: rem(8) }),
    },
    iconContainer: {
        width: ICON_CONTAINER_SIZE,
        height: ICON_CONTAINER_SIZE,
        marginRight: rem(16),
        alignItems: 'center',
        justifyContent: 'center',
    },
    infoContainer: { flex: 1 },
    infoRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    bullet: {
        fontWeight: '900',
    },
    wrapper: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
        // Other activity rows sit in an 8px-padded wrapper; this row is its own wrapper, so it takes the full 16
        ...(isWeb && { paddingHorizontal: rem(16) }),
    },
    firstItem: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
    },
    lastItem: {
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
    },
}));
export default memo(DividendActivityItem);
